{
  "actionbar.actions": "Toiminnot",
  "actionbar.actionsAvailable": "Toiminnot käytettävissä.",
  "actionbar.clearSelection": "Poista valinta",
  "actionbar.selected": "{count, plural, =0 {Ei mitään valittu} other {# valittu}}",
  "actionbar.selectedAll": "Kaikki valittu",
  "breadcrumbs.more": "Lisää kohteita",
  "button.pending": "odottaa",
  "calendar.invalidSelection": "{selectedCount, plural, one {Valittu päivämäärä ei ole} other {Valitut päivämäärät eivät ole}} saatavilla.",
  "combobox.noResults": "Ei tuloksia",
  "contextualhelp.help": "Ohje",
  "contextualhelp.info": "Tiedot",
  "datepicker.endTime": "Päättymisaika",
  "datepicker.startTime": "Alkamisaika",
  "datepicker.time": "Aika",
  "dialog.alert": "Hälytys",
  "dialog.dismiss": "Hylkää",
  "dropzone.replaceMessage": "Pudota korvaava tiedosto",
  "inlinealert.informative": "Tiedot",
  "inlinealert.negative": "Virhe",
  "inlinealert.notice": "Varoitus",
  "inlinealert.positive": "Onnistui",
  "label.(optional)": "(valinnainen)",
  "label.(required)": "(pakollinen)",
  "menu.moreActions": "Lisää toimintoja",
  "notificationbadge.indicatorOnly": "Uusi toiminta",
  "notificationbadge.plus": "{notifications}+",
  "picker.placeholder": "Valitse…",
  "picker.selectedCount": "{count, plural, =0 {Ei yhtään kohdetta valittu} one {# kohde valittu} other {# kohdetta valittu}}",
  "slider.maximum": "Maksimi",
  "slider.minimum": "Minimi",
  "table.loading": "Ladataan…",
  "table.loadingMore": "Ladataan lisää…",
  "table.resizeColumn": "Muuta sarakkeen kokoa",
  "table.sortAscending": "Lajittelujärjestys: nouseva",
  "table.sortDescending": "Lajittelujärjestys: laskeva",
  "tag.actions": "Toiminnot",
  "tag.hideButtonLabel": "Näytä vähemmän",
  "tag.noTags": "Ei mitään",
  "tag.showAllButtonLabel": "Näytä kaikki ({tagCount, number})",
  "toast.clearAll": "Tyhjennä kaikki",
  "toast.collapse": "Pienennä",
  "toast.showAll": "Näytä kaikki"
}
